import ReactMarquee from "react-fast-marquee";

const items = [
  "FROSTICO",
  "LAUNCHING DORSET & HAMPSHIRE · SEPTEMBER 2026",
  "ONLY IN DORSET AND HAMPSHIRE, UK",
  "FIRST OF ITS KIND",
  "15% PROFIT SHARE",
  "SELF-SERVE · 24/7",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative border-y border-white/10 bg-[#8B5CF6] py-6 overflow-hidden"
    >
      <ReactMarquee gradient={false} speed={60} pauseOnHover={false}>
        {[...items, ...items, ...items].map((t, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-5xl font-bold tracking-tighter text-[#0A0B10] mx-8"
          >
            {t}
            <span className="mx-8 text-white">✦</span>
          </span>
        ))}
      </ReactMarquee>
    </section>
  );
}
